<vy-box [boxLevel]="boxLevelEnum.LEVEL_TWO">
  <ng-container box-content>
    <div class="vy-booking-details_container">
      <div class="vy-booking-details_content-wrap">
        <div class="vy-booking-details_content_list">
          <ul vy-list [iconSmall]="false" [listSize]="listSizeEnum.L">
            @for(item of sharedBookingServices; track item; let last = $last){
            <li
              vy-list-item
              [listSize]="listSizeEnum.L"
              [separated]="true"
              [customIconClass]="serviceCategories[item].icon"
              [class]="last ? '' : 'marginBottom-m'"
            >
              <span vyListItemLabel>{{ serviceCategories[item].label | translate }}</span>
              <span vyListItemCustomComponent>
                <vy-icon [type]="iconTypeEnum.SUCCESS" [size]="iconSizeEnum.S" icon="ds-icon-check-solid"></vy-icon>
              </span>
            </li>
            }
          </ul>
        </div>
      </div>
    </div></ng-container
  ></vy-box
>
